package devxertech.com.utils

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit

enum class APIMETHODS { GET, POST }


suspend fun httpJsonRequest(
    url: String,
    method: APIMETHODS,
    body: String? = null,
    headers: Map<String, String>? = null
): String? {
    return try {
        val requestInit = RequestInit(
            method = method.name,
            headers = Headers().apply {
                append("Content-Type", "application/json")
                headers?.forEach { (key, value) ->
                    append(key, value)
                }
            },
            body = body?.takeIf { method != APIMETHODS.GET }
        )

        val response = window.fetch(url, requestInit).await()

        if (!response.ok) {
            val errorBody = response.text().await()
            console.error("HTTP ${response.status}: $errorBody")
            return errorBody
        }

        response.text().await()

    } catch (e: Exception) {
        console.error("HTTP request failed: ${e.message}")
        null
    }
}

